<script lang="ts">
	import { selectedOS } from '$lib/stores/os-selection';
	
	function selectOS(os: 'macos' | 'windows' | 'linux') {
		selectedOS.set(os);
	}
</script>

<div class="os-selector">
	<div class="os-selector__buttons">
		<button
			class="os-selector__button"
			class:os-selector__button--active={$selectedOS === 'macos'}
			onclick={() => selectOS('macos')}
			aria-label="macOS"
			title="macOS"
		>
			<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
				<path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
			</svg>
		</button>
		<button
			class="os-selector__button"
			class:os-selector__button--active={$selectedOS === 'windows'}
			onclick={() => selectOS('windows')}
			aria-label="Windows"
			title="Windows"
		>
			<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
				<path d="M3 5.5L10 4.5V11.5H3V5.5ZM10 12.5V19.5L3 18.5V12.5H10ZM11 4.33L20 3V11.5H11V4.33ZM20 12.5V21L11 19.67V12.5H20Z"/>
			</svg>
		</button>
		<button
			class="os-selector__button"
			class:os-selector__button--active={$selectedOS === 'linux'}
			onclick={() => selectOS('linux')}
			aria-label="Linux"
			title="Linux"
		>
			<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
				<path d="M12,5A3.5,3.5 0 0,0 8.5,8.5C8.5,9.5 8.9,10.4 9.5,11.1V12.5C9.5,13.6 10.4,14.5 11.5,14.5H12.5C13.6,14.5 14.5,13.6 14.5,12.5V11.1C15.1,10.4 15.5,9.5 15.5,8.5A3.5,3.5 0 0,0 12,5M12,2A6.5,6.5 0 0,1 18.5,8.5C18.5,10.2 17.8,11.7 16.7,12.8V13.5A2.5,2.5 0 0,1 14.2,16H12.8L12,16.8L11.2,16H9.8A2.5,2.5 0 0,1 7.3,13.5V12.8C6.2,11.7 5.5,10.2 5.5,8.5A6.5,6.5 0 0,1 12,2M10.5,9.5A1,1 0 0,1 9.5,10.5A1,1 0 0,1 8.5,9.5A1,1 0 0,1 9.5,8.5A1,1 0 0,1 10.5,9.5M15.5,9.5A1,1 0 0,1 14.5,10.5A1,1 0 0,1 13.5,9.5A1,1 0 0,1 14.5,8.5A1,1 0 0,1 15.5,9.5M12,17C12.6,17 13.1,17.2 13.5,17.5L14.3,16.7C14.7,16.3 15.2,16 15.8,16C16.7,16 17.5,16.7 17.5,17.5C17.5,18.4 16.8,19.1 15.9,19.1C15.3,19.1 14.8,18.8 14.5,18.4L13.7,19.2C13.3,19.6 12.8,19.9 12.2,19.9H11.8C11.2,19.9 10.7,19.6 10.3,19.2L9.5,18.4C9.2,18.8 8.7,19.1 8.1,19.1C7.2,19.1 6.5,18.4 6.5,17.5C6.5,16.7 7.3,16 8.2,16C8.8,16 9.3,16.3 9.7,16.7L10.5,17.5C10.9,17.2 11.4,17 12,17Z"/>
			</svg>
		</button>
	</div>
</div>

<style>
	.os-selector {
		display: inline-flex;
		align-items: center;
		padding: 0.25rem;
		background: var(--bg-secondary, #f8f9fa);
		border-radius: 8px;
		border: 1px solid var(--border-light, rgba(0, 0, 0, 0.08));
		margin-bottom: 1.5rem;
	}
	
	.os-selector__buttons {
		display: flex;
		gap: 0;
	}
	
	.os-selector__button {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0.5rem;
		background: transparent;
		border: none;
		border-radius: 6px;
		color: var(--text-secondary, #6b7280);
		cursor: pointer;
		transition: all 0.15s ease;
		position: relative;
	}
	
	.os-selector__button:hover {
		background: rgba(0, 0, 0, 0.05);
		color: var(--text-primary, #1f2937);
	}
	
	.os-selector__button--active {
		background: var(--brand-primary, #ff5e7e);
		color: white;
	}
	
	.os-selector__button--active:hover {
		background: var(--brand-primary-hover, #ff4567);
	}
	
	.os-selector__button svg {
		width: 18px;
		height: 18px;
	}
	
	.os-selector__button--active svg {
		opacity: 1;
	}
	
	/* Dark mode */
	:global([data-theme='dark']) .os-selector {
		background: rgba(255, 255, 255, 0.03);
		border-color: rgba(255, 255, 255, 0.1);
	}
	
	:global([data-theme='dark']) .os-selector__button {
		color: rgba(255, 255, 255, 0.6);
	}
	
	:global([data-theme='dark']) .os-selector__button:hover {
		background: rgba(255, 255, 255, 0.08);
		color: rgba(255, 255, 255, 0.9);
	}
	
	:global([data-theme='dark']) .os-selector__button--active {
		background: rgba(255, 122, 153, 0.2);
		color: #ff7a99;
	}
	
	:global([data-theme='dark']) .os-selector__button--active:hover {
		background: rgba(255, 122, 153, 0.25);
	}
</style>